// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Minimize2 } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMinimize2(props: any) {
    return <IconBase icon={Minimize2} {...props} />
  }

  export default IconMinimize2
  